import { DefineEvents, EventEmitter } from '../event-emitter/event-emitter';
import { EventEmitterImpl } from '../event-emitter/impls/event-emitter';
import { RpcImpl } from '../rpc/impls/rpc';
import { DefineRpcMethods, Rpc } from '../rpc/rpc';
import { ModelContext } from '../types';

export const ContextProxy = Symbol('ContextProxy');

export interface ContextState {
    /** 激活的（用户选择添加到对话的）上下文列表 */
    activeContexts: ModelContext[];
    /** 当前页面上下文 */
    currentContext?: {
        label?: string,
        context: ModelContext,
    };
    /** 建议上下文 */
    suggestionContext?: {
        label?: string,
        contexts: ModelContext[],
    };
    /** 最大上下文数量 */
    maxCount: number;
}

export enum PatentListProvideType {
    Select = 'select',
    CurrentPage = 'current-page',
}

export interface PatentListContext {
    provideType: PatentListProvideType;
    /** 实际选中的上下文数量，currentContexts 的长度是有效的上下文，小于等于 selectedLimit */
    selectedLength?: number;
    currentContexts: ModelContext[];
}

export type ContextEvents = DefineEvents<{
    'context-state-change': {
        module: string;
        state: ContextState;
    };
}>;

type RpcHiro = DefineRpcMethods<{
    /**
     * 设置专利列表上下文
     * @param context 专利列表上下文
     * @param module 模块名，用于区分不同的上下文管理器, 不传代表当前菜单上下文管理器，all 代表所有上下文管理器
     */
    setPatentListContext(context: PatentListContext, module?: string | 'all'): Promise<void>;

    /**
     * 添加上下文
     * @param context 上下文
     * @param module 模块名，用于区分不同的上下文管理器, 不传代表当前菜单上下文管理器，all 代表所有上下文管理器
     */
    addContext(context: ModelContext | ModelContext[], module?: string | 'all'): Promise<void>;

    /**
     * 删除上下文
     * @param context 上下文
     * @param module 模块名，用于区分不同的上下文管理器, 不传代表当前菜单上下文管理器，all 代表所有上下文管理器
     */
    removeContext(context: ModelContext | ModelContext[], module?: string | 'all'): Promise<void>;

    /**
     * 获取上下文状态
     * @param module 模块名，用于区分不同的上下文管理器, 不传代表当前菜单(agent)的上下文管理器
     */
    getContextState(module?: string): ContextState | null;

    /**
     * 只处理第一层属性
     * @param state 状态
     * @param module 模块名，用于区分不同的上下文管理器, 不传代表当前菜单上下文管理器，all 代表所有上下文管理器
     */
    patchContextState(state: Partial<ContextState>, module?: string | 'all'): Promise<void>;
}>;

export interface ContextProxy {
    eventProxy: EventEmitter<ContextEvents>;
    rpcHiro: Rpc<RpcHiro>;
}

export function createContextProxy(): ContextProxy {
    return {
        eventProxy: new EventEmitterImpl<ContextEvents>(),
        rpcHiro: new RpcImpl<RpcHiro>(),
    };
}
